/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Options from './Options';
import TankTypeResponse from './TankTypeResponse';

/**
* The SearchTankTypeResponse model module.
* @module model/SearchTankTypeResponse
* @version 2020-12-7
*/
export default class SearchTankTypeResponse {
    /**
    * Constructs a new <code>SearchTankTypeResponse</code>.
    * タンクタイプ検索レスポンス
    * @alias module:model/SearchTankTypeResponse
    * @class
    * @param tankTypes {Array.<module:model/TankTypeResponse>} タンクタイプ
    * @param result {module:model/SearchTankTypeResponse.ResultEnum} 
    */

    constructor(tankTypes, result) {
        
        
        this['tankTypes'] = tankTypes;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>SearchTankTypeResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SearchTankTypeResponse} obj Optional instance to populate.
    * @return {module:model/SearchTankTypeResponse} The populated <code>SearchTankTypeResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchTankTypeResponse();
                        
            
            if (data.hasOwnProperty('tankTypes')) {
                obj['tankTypes'] = ApiClient.convertToType(data['tankTypes'], [TankTypeResponse]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * タンクタイプ
    * @member {Array.<module:model/TankTypeResponse>} tankTypes
    */
    'tankTypes' = undefined;
    /**
    * @member {module:model/SearchTankTypeResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
